<script setup lang="ts">
// Behavioural port of AI SDK Elements' `Source` (Apache-2.0, Copyright Vercel); anatomy only.

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { SquareArrowRightUpIcon } from '@solar-icons/vue/linear'
import AppFavicon from '../../primitives/AppFavicon/AppFavicon.vue'
import { sourceDomain, type SourceEntry } from './source-types'

const props = defineProps<{
  source: SourceEntry
}>()

defineEmits<{
  open: [slug: string]
}>()

const { t } = useI18n()

const isWeb = computed(() => props.source.kind === 'web')

const label = computed(() => props.source.title ?? sourceDomain(props.source.ref))

const detail = computed(() =>
  isWeb.value ? sourceDomain(props.source.ref) : t('chat.sources.yourKnowledge'),
)
</script>

<template>
  <component
    :is="isWeb ? 'a' : 'button'"
    v-bind="
      isWeb
        ? { href: source.ref, target: '_blank', rel: 'noopener noreferrer' }
        : { type: 'button' }
    "
    class="flex w-full min-w-0 items-center gap-8 rounded-1 px-4 py-2 text-left hover:bg-bg-tertiary"
    @click="isWeb ? undefined : $emit('open', source.ref)"
  >
    <AppFavicon :src="source.favicon" :kind="source.kind" />
    <span class="min-w-0 flex-1 truncate text-body-sm text-text-primary">{{ label }}</span>
    <span class="shrink-0 text-caption text-text-tertiary">{{ detail }}</span>
    <SquareArrowRightUpIcon v-if="isWeb" class="shrink-0 text-icon-tertiary" />
  </component>
</template>
